import styled from 'styled-components'
import { transparentize } from 'polished'

import {
    themeColor,
    themeFontSize,
} from '@elparking/components'

const alphaRedColor = (props) => transparentize(0.95, themeColor('red')(props))

const Alert = styled.div`
    color: ${themeColor('gray')};
    font-size: ${themeFontSize('xxSmall')};
    background-color: ${alphaRedColor};
    padding: 12px;
    border: 1px solid ${themeColor('red')};
`

export default Alert
